import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';

export const useIsStorageEnforcementEligible = (): boolean => {
	const { edition, isLoggedIn } = useSessionData();
	const isEligibleUser = edition === ConfluenceEdition.FREE && isLoggedIn;

	return isEligibleUser;
};
